// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Dropdown button styles
 */
.bolt-dropdown-button {
  display: inline-flex;
}

.bolt-dropdown-button .icon-right {
  font-size: 0.75rem;
  padding-left: 10px;
}

/*# sourceMappingURL=MenuButton.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Menu/MenuButton.scss","webpack://./../azure-devops-ui/bin/Components/Menu/MenuButton.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AACA;;EAAA;AAGA;EACI,oBAAA;ACAJ;;ADGA;EACI,kBEqQO;EFpQP,kBAAA;ACAJ;;AAEA,yCAAyC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
